import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const API_BASE_URL = "https://dashboard.jyotirvani.com/api";

const getActiveCartKey = () => {
  const user = JSON.parse(localStorage.getItem("user") || "null");
  return user?.email ? `cart_${user.email}` : "cart_guest";
};

const Checkout = () => {
  const [cart, setCart] = useState([]);
  const [userDetails, setUserDetails] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
  });

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkoutSummary =
      JSON.parse(localStorage.getItem("checkoutSummary")) || null;

    const cartKey =
      localStorage.getItem("checkoutCartKey") || getActiveCartKey();

    const savedCart =
      checkoutSummary?.cart?.length > 0
        ? checkoutSummary.cart
        : JSON.parse(localStorage.getItem(cartKey)) || [];

    if (savedCart.length === 0) {
      navigate("/cart");
      return;
    }

    setCart(savedCart);

    const user = JSON.parse(localStorage.getItem("user")) || {};

    setUserDetails({
      name: user.name || user.first_name || "",
      email: user.email || "",
      phone: user.phone || "",
      address: user.address || "",
      city: user.city || "",
      state: user.state || "",
      pincode: user.pincode || "",
    });
  }, [navigate]);

  const totalPrice = cart.reduce(
    (total, item) =>
      total + Number(item.price || 0) * Number(item.quantity || 1),
    0,
  );

  const totalItems = cart.reduce(
    (total, item) => total + Number(item.quantity || 1),
    0,
  );

  const deliveryCharge = totalPrice >= 499 ? 0 : 49;
  const grandTotal = totalPrice + deliveryCharge;

  const handleInputChange = (e) => {
    setUserDetails({
      ...userDetails,
      [e.target.name]: e.target.value,
    });
  };

  const handlePayment = async () => {
    const { name, email, phone, address, city, state, pincode } = userDetails;

    if (!name || !email || !phone || !address || !city || !state || !pincode) {
      alert("Please fill all delivery details");
      return;
    }

    if (!/^\d{10}$/.test(phone)) {
      alert("Please enter valid 10 digit phone number");
      return;
    }

    if (!/^\d{6}$/.test(pincode)) {
      alert("Please enter valid 6 digit pincode");
      return;
    }

    try {
      setLoading(true);

      const orderId = "JV_" + Date.now();
      const user = JSON.parse(localStorage.getItem("user") || "null");

      const lastOrderKey = user?.email
        ? `lastOrderId_${user.email}`
        : "lastOrderId_guest";

      localStorage.setItem(lastOrderKey, orderId);

      const pendingOrder = {
        order_id: orderId,
        cart,
        customer: userDetails,
        totalItems,
        totalPrice,
        deliveryCharge,
        grandTotal,
        orderDate: new Date().toISOString(),
      };

      const pendingOrderKey = user?.email
        ? `pendingOrder_${user.email}`
        : "pendingOrder_guest";

      localStorage.setItem(pendingOrderKey, JSON.stringify(pendingOrder));

      localStorage.setItem(
        "checkoutSummary",
        JSON.stringify({
          cart,
          totalItems,
          totalPrice,
          deliveryCharge,
          grandTotal,
        }),
      );

      const res = await fetch(`${API_BASE_URL}/generate-token`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          order_id: orderId,
          amount: Number(grandTotal),
          name,
          email,
          phone,
          address,
          city,
          state,
          pincode,
          cart_items: cart,
          type: "cart_checkout",
        }),
      });

      const data = await res.json();
      console.log("RAZORPAY RESPONSE:", data);

      if (!res.ok || !data.status) {
        alert(data.message || "Payment API failed");
        setLoading(false);
        return;
      }

      if (!window.Razorpay) {
        alert("Razorpay SDK not loaded. index.html e script add koro.");
        setLoading(false);
        return;
      }

      const options = {
        key: data.key,
        amount: data.amount,
        currency: data.currency || "INR",
        name: "JyotirVani",
        description: "Order Payment",
        order_id: data.order_id,

        handler: async function (response) {
          try {
            const verifyRes = await fetch(
              `${API_BASE_URL}/verify-razorpay-payment`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                },
                body: JSON.stringify({
                  razorpay_order_id: response.razorpay_order_id,
                  razorpay_payment_id: response.razorpay_payment_id,
                  razorpay_signature: response.razorpay_signature,
                  local_order_id: orderId,
                  return_type: "cart",
                }),
              },
            );

            const verifyData = await verifyRes.json();

           if (verifyData.status) {
  const ordersKey = user?.email
    ? `orders_${user.email}`
    : "orders_guest";

  const oldOrders =
    JSON.parse(localStorage.getItem(ordersKey)) || [];

  const newOrder = {
    order_id: orderId,
    cart,
    customer: userDetails,
    totalItems,
    totalPrice,
    deliveryCharge,
    grandTotal,
    payment_status: "success",
    orderDate: new Date().toISOString(),
  };

  localStorage.setItem(
    ordersKey,
    JSON.stringify([newOrder, ...oldOrders])
  );

  const checkoutCartKey = localStorage.getItem("checkoutCartKey");

  if (checkoutCartKey) {
    localStorage.removeItem(checkoutCartKey);
  }

  localStorage.removeItem("checkoutSummary");
  localStorage.removeItem("checkoutCartKey");

  window.dispatchEvent(new Event("cartUpdated"));

  navigate(`/TrackOrder/${orderId}?payment=success`);
} else {
  alert(verifyData.message || "Payment verification failed");
  setLoading(false);
}
          } catch (err) {
            console.error("VERIFY ERROR:", err);
            alert("Payment verification failed");
            setLoading(false);
          }
        },

        prefill: {
          name,
          email,
          contact: phone,
        },

        notes: {
          order_id: orderId,
          address,
          city,
          state,
          pincode,
        },

        theme: {
          color: "#7c3aed",
        },

        modal: {
          ondismiss: function () {
            setLoading(false);
          },
        },
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();
    } catch (error) {
      console.error("Checkout Error:", error);
      alert(error?.message || "Payment failed. Console check koro.");
      setLoading(false);
    }
  };

  return (
    <>
      <style>{`
        @media (max-width: 900px) {
          .checkout-grid-fix { grid-template-columns: 1fr !important; }
          .checkout-summary-fix { position: static !important; top: auto !important; }
        }

        @media (max-width: 600px) {
          .checkout-page-fix { padding: 14px 10px !important; }
          .checkout-title-fix { font-size: 28px !important; line-height: 1.2 !important; }
          .checkout-hero-text-fix { font-size: 14px !important; line-height: 1.5 !important; }
          .checkout-steps-fix { grid-template-columns: repeat(2, 1fr) !important; gap: 10px !important; }
          .checkout-step-fix { min-height: 125px !important; padding: 12px !important; border-radius: 18px !important; }
          .checkout-step-icon-fix { font-size: 24px !important; margin-bottom: 8px !important; }
          .checkout-step-title-fix { font-size: 14px !important; line-height: 1.3 !important; }
          .checkout-step-text-fix { font-size: 12px !important; line-height: 1.4 !important; }
          .checkout-card-fix, .checkout-summary-fix { padding: 18px !important; border-radius: 20px !important; }
          .checkout-form-grid-fix { gap: 14px !important; }
          .checkout-cart-item-fix { align-items: flex-start !important; }
          .checkout-cart-item-fix strong { font-size: 13px !important; white-space: nowrap !important; }
        }

        @media (max-width: 380px) {
          .checkout-steps-fix { grid-template-columns: 1fr !important; }
        }
      `}</style>

      <div style={pageStyle} className="checkout-page-fix">
        <div style={containerStyle}>
          <div style={heroStyle}>
            <h1
              className="checkout-title-fix"
              style={{ margin: 0, fontSize: "34px", fontWeight: "800" }}
            >
              Checkout
            </h1>

            <p
              className="checkout-hero-text-fix"
              style={{ margin: "10px 0 0", opacity: 0.92 }}
            >
              Fill Address → Complete Payment → Live Order Tracking
            </p>
          </div>

          <div style={stepsStyle} className="checkout-steps-fix">
            {[
              ["🛒", "Cart", "Completed"],
              [
                "💳",
                "Checkout & Payment",
                "Add address & complete secure payment",
              ],
              ["🚚📍", "Delivery & Track", "Track your JyotirVani order live"],
            ].map((step, index) => (
              <div
                key={index}
                className="checkout-step-fix"
                style={{
                  ...stepCardStyle,
                  border:
                    index === 1 ? "2px solid #7c3aed" : "1px solid #e5e7eb",
                }}
              >
                <div
                  className="checkout-step-icon-fix"
                  style={{ fontSize: "26px", marginBottom: "8px" }}
                >
                  {step[0]}
                </div>

                <h3
                  className="checkout-step-title-fix"
                  style={{ margin: "8px 0 4px", fontSize: "16px" }}
                >
                  {step[1]}
                </h3>

                <p
                  className="checkout-step-text-fix"
                  style={{ margin: 0, color: "#6b7280", fontSize: "13px" }}
                >
                  {step[2]}
                </p>
              </div>
            ))}
          </div>

          <div style={checkoutGridStyle} className="checkout-grid-fix">
            <div style={cardStyle} className="checkout-card-fix">
              <h2 style={{ marginTop: 0 }}>Delivery Details</h2>

              <div
                style={{ display: "grid", gap: "18px" }}
                className="checkout-form-grid-fix"
              >
                <InputField
                  label="Full Name"
                  name="name"
                  value={userDetails.name}
                  onChange={handleInputChange}
                />

                <InputField
                  label="Email Address"
                  name="email"
                  type="email"
                  value={userDetails.email}
                  onChange={handleInputChange}
                />

                <InputField
                  label="Phone Number"
                  name="phone"
                  type="tel"
                  value={userDetails.phone}
                  onChange={handleInputChange}
                />

                <div>
                  <label style={labelStyle}>Delivery Address *</label>
                  <textarea
                    name="address"
                    value={userDetails.address}
                    onChange={handleInputChange}
                    rows="4"
                    placeholder="Enter full delivery address"
                    style={{ ...inputStyle, resize: "vertical" }}
                  />
                </div>

                <InputField
                  label="City"
                  name="city"
                  value={userDetails.city}
                  onChange={handleInputChange}
                />

                <InputField
                  label="State"
                  name="state"
                  value={userDetails.state}
                  onChange={handleInputChange}
                />

                <InputField
                  label="Pincode"
                  name="pincode"
                  value={userDetails.pincode}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div style={summaryCardStyle} className="checkout-summary-fix">
              <h2 style={{ marginTop: 0 }}>Order Summary</h2>

              <div style={{ marginBottom: "18px" }}>
                {cart.slice(0, 3).map((item, index) => (
                  <div
                    key={`${item.id || item.name}-${index}`}
                    style={cartItemStyle}
                    className="checkout-cart-item-fix"
                  >
                    <img
                      src={item.image}
                      alt={item.name}
                      style={cartImageStyle}
                    />

                    <div style={{ flex: 1 }}>
                      <h4 style={{ margin: 0, fontSize: "14px" }}>
                        {item.name}
                      </h4>

                      {(item.size || item.unit) && (
                        <p
                          style={{
                            margin: "4px 0 0",
                            color: "#7c3aed",
                            fontSize: "12px",
                            fontWeight: 800,
                          }}
                        >
                          {item.size} {item.unit}
                        </p>
                      )}

                      <p style={cartTextStyle}>
                        Qty: {item.quantity || 1} × ₹{item.price}
                      </p>
                    </div>

                    <strong style={{ color: "#7c3aed" }}>
                      ₹{Number(item.price || 0) * Number(item.quantity || 1)}
                    </strong>
                  </div>
                ))}
              </div>

              <SummaryRow
                label={`Subtotal (${totalItems} items)`}
                value={`₹${totalPrice}`}
              />

              <SummaryRow
                label="Delivery Charge"
                value={deliveryCharge === 0 ? "Free" : `₹${deliveryCharge}`}
              />

              <div style={totalRowStyle}>
                <span>Total</span>
                <span style={{ color: "#7c3aed" }}>₹{grandTotal}</span>
              </div>

              <button
                onClick={handlePayment}
                disabled={loading}
                style={{
                  ...payButtonStyle,
                  background: loading
                    ? "#9ca3af"
                    : "linear-gradient(135deg, #16a34a, #22c55e)",
                  cursor: loading ? "not-allowed" : "pointer",
                }}
              >
                {loading ? "Redirecting..." : "Pay Now"}
              </button>

              <button
                onClick={() => navigate("/cart")}
                style={outlineButtonStyle}
              >
                Back To Cart
              </button>

              <div style={supportBoxStyle} className="cart-info-box">
                <h3 style={supportTitleStyle}>Need Help?</h3>

                <a
                  href="mailto:support@jyotirvani.com"
                  style={supportMailStyle}
                >
                  📧 support@jyotirvani.com
                </a>

                <a href="tel:+919616339090" style={supportPhoneStyle}>
                  📞 +91 96163 39090
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const InputField = ({ label, name, value, onChange, type = "text" }) => (
  <div>
    <label style={labelStyle}>{label} *</label>
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={`Enter ${label.toLowerCase()}`}
      style={inputStyle}
    />
  </div>
);

const SummaryRow = ({ label, value }) => (
  <div style={summaryRowStyle}>
    <span>{label}</span>
    <strong>{value}</strong>
  </div>
);

const pageStyle = {
  minHeight: "100vh",
  background:
    "radial-gradient(circle at top left, #fff7ed 0, #ffffff 38%, #f3e8ff 100%)",
  padding: "clamp(14px, 3vw, 30px)",
  fontFamily: "Arial, sans-serif",
  boxSizing: "border-box",
};

const containerStyle = {
  maxWidth: "1150px",
  width: "100%",
  margin: "0 auto",
};

const heroStyle = {
  background: "linear-gradient(135deg, #3b0764, #7c3aed, #f97316)",
  borderRadius: "clamp(20px, 4vw, 28px)",
  padding: "clamp(22px, 4vw, 34px)",
  color: "#fff",
  marginBottom: "22px",
  boxShadow: "0 20px 45px rgba(76,29,149,0.25)",
};

const stepsStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
  gap: "12px",
  marginBottom: "22px",
};

const stepCardStyle = {
  background: "rgba(255,255,255,0.92)",
  borderRadius: "18px",
  padding: "15px",
  boxShadow: "0 12px 30px rgba(15,23,42,0.08)",
};

const checkoutGridStyle = {
  display: "grid",
  gridTemplateColumns: "minmax(0, 1fr) minmax(310px, 390px)",
  gap: "22px",
  alignItems: "start",
};

const cardStyle = {
  background: "rgba(255,255,255,0.94)",
  borderRadius: "24px",
  padding: "clamp(18px, 3vw, 26px)",
  boxShadow: "0 18px 45px rgba(15,23,42,0.08)",
  border: "1px solid #ede9fe",
};

const summaryCardStyle = {
  background: "rgba(255,255,255,0.96)",
  borderRadius: "24px",
  padding: "clamp(18px, 3vw, 24px)",
  boxShadow: "0 18px 45px rgba(15,23,42,0.08)",
  border: "1px solid #ede9fe",
  position: "sticky",
  top: "20px",
};

const labelStyle = {
  display: "block",
  marginBottom: "7px",
  color: "#111827",
  fontWeight: "800",
  fontSize: "14px",
};

const inputStyle = {
  width: "100%",
  padding: "14px 15px",
  border: "1px solid #ddd6fe",
  borderRadius: "15px",
  fontSize: "15px",
  outline: "none",
  boxSizing: "border-box",
  background: "#fff",
};

const cartItemStyle = {
  display: "flex",
  gap: "12px",
  alignItems: "center",
  background: "#f9fafb",
  borderRadius: "16px",
  padding: "11px",
  marginBottom: "10px",
};

const cartImageStyle = {
  width: "52px",
  height: "52px",
  borderRadius: "12px",
  objectFit: "cover",
  flexShrink: 0,
};

const cartTextStyle = {
  margin: "4px 0 0",
  color: "#6b7280",
  fontSize: "13px",
};

const summaryRowStyle = {
  display: "flex",
  justifyContent: "space-between",
  gap: "12px",
  marginBottom: "12px",
  color: "#4b5563",
  fontSize: "15px",
};

const totalRowStyle = {
  borderTop: "1px dashed #d1d5db",
  marginTop: "15px",
  paddingTop: "15px",
  display: "flex",
  justifyContent: "space-between",
  gap: "12px",
  fontSize: "20px",
  fontWeight: "900",
};

const payButtonStyle = {
  width: "100%",
  marginTop: "22px",
  border: "none",
  borderRadius: "999px",
  padding: "15px",
  color: "#fff",
  fontWeight: "900",
  fontSize: "16px",
  boxShadow: "0 12px 25px rgba(34,197,94,0.25)",
};

const outlineButtonStyle = {
  width: "100%",
  marginTop: "12px",
  border: "2px solid #7c3aed",
  borderRadius: "999px",
  padding: "13px",
  background: "#fff",
  color: "#7c3aed",
  fontWeight: "900",
  cursor: "pointer",
};

const supportBoxStyle = {
  marginTop: "18px",
  background: "linear-gradient(135deg, #f5f3ff, #fff7ed)",
  border: "1px solid #ede9fe",
  borderRadius: "18px",
  padding: "16px",
  boxShadow: "0 10px 24px rgba(124,58,237,0.08)",
};

const supportTitleStyle = {
  margin: "0 0 12px",
  color: "#4c1d95",
  fontSize: "17px",
  fontWeight: "900",
};

const supportMailStyle = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  textDecoration: "none",
  background: "#ffffff",
  color: "#6d28d9",
  padding: "12px 14px",
  borderRadius: "14px",
  fontWeight: "800",
  fontSize: "14px",
  marginBottom: "10px",
  border: "1px solid #ede9fe",
};

const supportPhoneStyle = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  textDecoration: "none",
  background: "#ecfdf5",
  color: "#16a34a",
  padding: "12px 14px",
  borderRadius: "14px",
  fontWeight: "800",
  fontSize: "14px",
  border: "1px solid #bbf7d0",
};

export default Checkout;
